import { Component, OnDestroy, OnInit } from '@angular/core';
import { GetExercisesResponseDTO } from '../doggyhub.dto';
import { Subscription } from 'rxjs';
import { DoggyhubService } from '../doggyhub.service';

@Component({
  selector: 'app-exercises',
  templateUrl: './exercises.page.html',
  styleUrls: ['./exercises.page.scss'],
})
export class ExercisesPage implements OnInit, OnDestroy {
  exercisesSub: Subscription;
  exercises: GetExercisesResponseDTO[];
  allExercises: GetExercisesResponseDTO[];
  isLoading = true;
  filter = 'dogs';
  constructor(private doggyhubService: DoggyhubService) { }

  ngOnInit() {
    this.filter = localStorage.getItem('animalFilter') || 'dogs';
    this.exercisesSub = this.doggyhubService
      .getExercises()
      .subscribe((exercises) => {
        this.allExercises = exercises;
        this.filterExercises();
        this.isLoading = false;
      });
  }

  handleRefresh(event: any) {
    this.exercisesSub = this.doggyhubService
      .getExercises()
      .subscribe((exercises) => {
        this.allExercises = exercises;
        this.filterExercises();
        this.isLoading = false;
        event.target.complete();
      });
  }

  ngOnDestroy() {
    if (this.exercisesSub) this.exercisesSub.unsubscribe();
  }

  filterExercises() {
    if (this.filter === 'dogs') {
      this.exercises = this.allExercises.filter(
        (exercise) => exercise.petTypeId === 1
      );
      localStorage.setItem('animalFilter', this.filter);
    } else if (this.filter === 'cats') {
      this.exercises = this.allExercises.filter(
        (exercise) => exercise.petTypeId === 2
      );
      localStorage.setItem('animalFilter', this.filter);
    } else {
      this.exercises = this.allExercises;
    }
  }
}
